module.exports = __webpack_public_path__ + "static/media/fa-qs.f981ccf3.svg";